module.exports = __webpack_public_path__ + "img/62.8fbc4f06.jpg";